import { getProductBrand } from "@shared/config/productBrand";

export interface LockScreenBranding {
  organizationDisplayName: string;
  logoUrl?: string;
}

const MAX_DISPLAY_NAME_LENGTH = 80;

function defaultOrganizationDisplayName(): string {
  return getProductBrand().lockScreenDisplayName;
}

function sanitizeDisplayName(value?: string): string {
  const fallback = defaultOrganizationDisplayName();
  if (!value) {
    return fallback;
  }

  const trimmed = value.trim();
  if (!trimmed || trimmed.length > MAX_DISPLAY_NAME_LENGTH) {
    return fallback;
  }

  // Minimal branding only: allow common brand characters and spaces.
  if (!/^[A-Za-z0-9 .&'()-]+$/.test(trimmed)) {
    return fallback;
  }

  return trimmed;
}

function sanitizeLogoUrl(value?: string): string | undefined {
  if (!value) {
    return undefined;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return undefined;
  }

  // Allow same-origin relative path or absolute http(s) URL only.
  if (trimmed.startsWith("/")) {
    return trimmed;
  }

  try {
    const parsed = new URL(trimmed);
    if (parsed.protocol === "http:" || parsed.protocol === "https:") {
      return trimmed;
    }
  } catch {
    return undefined;
  }

  return undefined;
}

export function getLockScreenBranding(): LockScreenBranding {
  const organizationDisplayName = sanitizeDisplayName(
    import.meta.env.VITE_LOCK_SCREEN_ORG_NAME,
  );
  const logoUrl = sanitizeLogoUrl(import.meta.env.VITE_LOCK_SCREEN_LOGO_URL);

  return {
    organizationDisplayName,
    logoUrl,
  };
}
